<div class="modal-header">
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Fee Summary - {{data.permitNumber}}</h4>
</div>

<div class="modal-body">
    <ng-container *ngIf="dataLoaded">
        <p-table #dt styleClass="p-datatable-striped"
                 [value]="feeSummaryModel">
            <ng-template pTemplate="header">
                <tr>
                    <th colspan="10">Product</th>
                    <th colspan="2">Fee Amount</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td [attr.colspan]="12">
                        No records found
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data>
                <tr [pSelectableRow]="true">
                    <td colspan="10">{{ data.productDisplayValue }}</td>
                    <td colspan="2">{{ data.feeAmount | currency }}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="footer">
                <tr *ngIf="feeSummaryModel.length > 0">
                    <td colspan="10" class="text-right">
                        <b>Total</b>
                    </td>
                    <td colspan="2">
                        <b>{{ feeAmountTotal | currency }}</b>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </ng-container>
</div>